import React, { createContext, useContext, useState, useEffect } from 'react';

import { apiService } from '../Services/apiService';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// Farklı DB tiplerinden (boolean / 1 / Buffer) gelen bayrağı normalize eder
const truthy = (v) =>
  v === true || v === 1 || v === '1' || (typeof v === 'object' && v && v[0] === 1);

// Yarışma başlatıp yönetebilen kariyerler — mobil PlayerJoinPage.dart ile birebir.
// "Bronz Aslan ve üstü"; alt kariyerler (Sekiz Yıldız vb.) sadece katılımcıdır.
const YETKILI_KARIYERLER = [
  'Bronz Aslan',
  'Gümüş Aslan',
  'Altın Aslan',
  'Yıldız Altın Aslan',
  'Yönetici',
  'Onursal Yönetici',
];

// Panele girebilenler: admin (utadmin) VEYA user_yetkiler bayrağı VEYA
// Bronz Aslan+ kariyer. Backend'deki verifyContestManager kapısı ile aynı.
export const isPanelAuthorized = (u) =>
  !!u && (
    truthy(u.isAdmin) ||
    truthy(u.isYetkili) ||
    YETKILI_KARIYERLER.includes(String(u.kariyer || '').trim())
  );

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check local storage for persistent login
    const storedUser = localStorage.getItem('contest_user');
    const token = localStorage.getItem('token');
    if (storedUser && token) {
      const parsed = JSON.parse(storedUser);
      // Kayıtlı oturum yetkisizse (ör. yetki geri alınmış) temizle
      if (isPanelAuthorized(parsed)) {
        setUser(parsed);
      } else {
        localStorage.removeItem('contest_user');
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
        const response = await apiService.login(email, password);
        // response returns: { message: "enter", token: "...", info: { ... } }
        const userData = response.info;

        // Yetki kapısı: admin veya yetkili değilse panele alma
        if (!isPanelAuthorized(userData)) {
            return {
                success: false,
                message: 'Bu panele erişim yetkiniz yok. Yalnızca yöneticiler ve yetkili kullanıcılar giriş yapabilir.'
            };
        }

        setUser(userData);
        localStorage.setItem('contest_user', JSON.stringify(userData));
        localStorage.setItem('token', response.token);
        return { success: true };
    } catch (err) {
        console.error("Login failed:", err);
        return { success: false, message: err.message };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('contest_user');
    localStorage.removeItem('token');
    localStorage.removeItem('activeRoomPin'); // Başka bir admin girişinde eski oyunu miras bırakma
    localStorage.removeItem('activeGameId');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
